export default "__VITE_ASSET__ZHAADInW__"